//import axiosLoadingIndicatorFactory from '../axios-loading-indicator';
import axios from 'axios';
import handlers from './default-handlers';

export default {
    getUsers(vue, all, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.leaderboard.users, {
            params: {
                all: !!all
            }
        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    getTeams(vue, all, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.leaderboard.teams, {
            params: {
                all: !!all
            }
        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    getCompanysteps(vue, all, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.leaderboard.companysteps, {
            params: {
                all: !!all
            }
        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    getStepsGroupCompany(vue, all, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.leaderboard.getStepsGroupCompany, {
            params: {
                all: !!all
            }
        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    getCompanies(vue, all, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.leaderboard.companies, {
            params: {
                all: !!all
            }
        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    getCompanyCompetition(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.leaderboard.companyCompetition)
            .then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
}
